import UpsellView from "compid/shared/views/UpsellView";
import React from "react";

/**
 * @function TrialeBillUpsellView 
 * @param {STRING} daysRemaining Pass the number of days remaining for the Trail eBill Upsell View.
 * @returns {React.Component}
 * @example
 * <TrialeBillUpsellView daysRemaining="5" />
 */


export default function TrialeBillUpsellView(props) {
  const daysRemaining = props.daysRemaining ?? "10";

  return (
      <UpsellView 
      text={`Only ${daysRemaining} days left to keep your eBill.`} 
      textClass="blue-text"/>
  )

}
